import React, { useContext } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { FiArrowUpRight } from "react-icons/fi";
import { GiExtraTime } from "react-icons/gi";

export default function OnePortfolio({ data }) {
  const appContext = useContext(AppContext);

  function viewDetails() {
    appContext.navTo({
      item: "view",
      subItem: "portfolio",
      extraItem: data.uuid
    });
  }

  // Safe Image URL Resolver (handles CDN, local uploads, or absolute URLs)
  const getImageUrl = (path) => {
    if (!path) return "";
    if (
      path.startsWith("http://") ||
      path.startsWith("https://") ||
      path.startsWith("data:")
    ) {
      return path;
    }
    const baseUrl = (CDN_URL || "http://localhost:5000").replace(/\/+$/, "");
    const cleanPath = path.replace(/^\/+/, "");
    return `${baseUrl}/${cleanPath}`;
  };

  const rawImg = data?.coverPhoto || data?.image || data?.logo || "";
  const photoUrl = getImageUrl(rawImg);

  const title = data?.title || data?.name || "Untitled Project";
  const type = data?.type || data?.category || "Systems";
  const description = data?.description || "";
  
  // Parse tags whether they come as an array or comma-separated string
  const tags = Array.isArray(data?.tags)
    ? data.tags
    : typeof data?.tags === "string"
    ? data.tags.split(",").map((t) => t.trim())
    : [];

  return (
    <div className="col-md-6 portfolio-reveal">
      <div className="portfolio-card" onClick={viewDetails} style={{ cursor: "pointer" }}>
        <div className="img-wrapper">
          <img src={CDN_URL + data.coverPhoto} alt={title} loading="lazy" />
        </div>
        <div className="portfolio-info">
          <span className="project-type-tag">{type}</span>
          <div className="d-flex justify-content-between align-items-start">
            <h3 className="fw-bold h4 m-0" style={{ color: "#0f172a" }}>
              {title}
            </h3>
            <div style={{ color: "var(--secondaryColor)" }}>
              <FiArrowUpRight size={24} />
            </div>
          </div>
          <p className="text-muted small mt-2 mb-4">{description}</p>
          {tags.length > 0 && (
            <div className="d-flex flex-wrap gap-2">
              {tags.map((tag, index) => (
                <span key={index} className="tag-pill">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}